import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import {
    selectContact,
    selectOwnExtensionKey,
} from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { getContactName } from 'flow/utils/contact-utils';

// Resolves an extension key to a display label: "You" for the logged-in
// user, the contact's name otherwise, or "Unknown" when the name can't be
// resolved. Returns undefined when no key is given, so callers with
// optional values don't need a sentinel.
const useExtensionDisplayName = (extensionKey: ExtensionKey | undefined) => {
    const { i18next } = useAppContext();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const contactName = useAppSelector((state) =>
        extensionKey && extensionKey !== ownExtensionKey
            ? getContactName(selectContact(state, extensionKey))
            : undefined,
    );

    if (!extensionKey) {
        return undefined;
    }
    if (extensionKey === ownExtensionKey) {
        return i18next.t('chat.you');
    }
    return contactName || i18next.t('Contact.Unknown');
};

export default useExtensionDisplayName;
